export const roundToNPlaces = (num: number, n: number): number => {
  const scale = Math.pow(10, n);
  return Math.round(num * scale) / scale;
};
